import { ref, computed, watch } from "@vue/composition-api";
import { useToast } from "vue-toastification/composition";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import moment from "moment-timezone";
import store from "@/store";
import router from "@/router";
import ability from "@/libs/acl/ability";
import { useUtils as useI18nUtils } from "@core/libs/i18n";
import { debounce } from "lodash";

export default function useList() {
  const { t } = useI18nUtils();
  const trans = {
    "messages.error.server_error": t("messages.error.server_error"),
  };
  const refListTable = ref(null);

  const toast = useToast();

  store.dispatch("permission/getAll");
  store.dispatch("layouts/getAll");

  const permissionsOptions = computed(() => store.getters["permission/getSelectedItems"]);
  const permissionsOptionsComplete = computed(() => store.getters["permission/getItems"]);
  const permissionsFilter = ref(null);

  const layoutsOptions = computed(() => store.getters["layouts/getItems"]);
  const layoutsFilter = ref(null);

  if (router.currentRoute.params.id_permission)
    permissionsFilter.value = parseInt(router.currentRoute.id_permission);

  const tableColumns = [
    { label: "profiles.title", key: "type", sortable: true },
    { label: "profiles.description", key: "description", sortable: true, tdClass: 'text-truncate td-description', thStyle: "max-width: 300px" },
    { label: "profiles.forced_layouts", key: "forced_layouts", sortable: true },
    { label: 'profiles.session_time', key: 'token_lifetime', sortable: true },
    { label: 'profiles.priority', key: 'priority', sortable: true },
    { label: 'profiles.inactivity_lifetime', key: 'inactivity_lifetime', sortable: true },
    // {
    //   label: "profiles.permissions",
    //   key: "permissions",
    //   sortable: false,
    //   formatter: (value, key, item) => {
    //     return value
    //       .map((item) => {
    //         return item.description;
    //       })
    //       .join(", ");
    //   },
    //   thStyle: "min-width: 500px",
    // },
  ];

  if (
    ability.can("update", "Profile") == true ||
    ability.can("delete", "Profile") == true ||
    ability.can("create", "Profile") == true
  ) {
    tableColumns.splice(0, 0, { label: "actions.name", key: "actions" });
  }

  const perPage = ref(10);
  const totalList = ref(0);
  const currentPage = ref(1);
  const perPageOptions = [10, 25, 50, 100];
  const searchQuery = ref("");
  const sortBy = ref("id");
  const isSortDirDesc = ref(true);

  const dataMeta = computed(() => {
    const localItemsCount = refListTable.value ? refListTable.value.localItems.length : 0;
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalList.value,
    };
  });

  const fetchList = (ctx, callback) => {
    store
      .dispatch("profile/getAll", {
        q: searchQuery.value,
        max: perPage.value,
        "page[n]": currentPage.value,
        sortBy: sortBy.value,
        sortDesc: isSortDirDesc.value,
        id_permission: permissionsFilter.value,
      })
      .then((response) => {
        callback(response.data);
        totalList.value = response.meta.total;
      })
      .catch(() => {
        toast({
          component: ToastificationContent,
          props: {
            title: trans["messages.error.server_error"],
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      });
  };

  const formatDateAssigned = (value) => {
    const formattedDate = moment(value).format("DD/MM/YYYY HH:mm:ss");
    return formattedDate;
  };

  const refetchData = () => {
    refListTable.value.refresh();
  };

  watch([permissionsFilter, currentPage, perPage ], () => {
    refetchData();
  });

  watch([ searchQuery ], debounce(() => {
    refetchData()
  }, 500));

  return {
    tableColumns,
    perPage,
    currentPage,
    totalList,
    fetchList,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refListTable,
    formatDateAssigned,
    permissionsOptions,
    permissionsOptionsComplete,
    permissionsFilter,
    refetchData,

    layoutsOptions,
  };
}
